// Page de désinscription de la prospection (D-086) : /u/<jeton>, lien en pied de chaque e-mail.
// SANS compte, au vouvoiement, aux couleurs d'Arceau. Deux choix, en un clic (jamais à l'ouverture du
// lien : les antivirus des messageries ouvrent tous les liens) : « Pas intéressé pour cette saison »
// (rien pendant 12 mois) ou « Ne plus recevoir d'e-mails » (définitif).
import { prospectOptout, prospectPage, type ProspectPage } from '../lib/api';
import { $$, html, mount, type Html } from './dom';
import { applyBrand } from './theme';

const SITE = 'https://arceau.app/';

export async function renderProspectOptout(root: HTMLElement, token: string): Promise<void> {
  applyBrand(null, false);
  document.title = 'Arceau · vos e-mails';
  let v: ProspectPage | null = null;
  try { v = await prospectPage(token); } catch { /* réseau : même message */ }
  const page = (body: Html) => mount(root, html`
    <div class="pub pu-pub">
      <header class="pub-head"><div class="pub-id"><span class="ball pu-ball" aria-hidden="true"></span>
        <div><h1>Arceau</h1><p>L’app des clubs de basket · vos e-mails</p></div></div></header>
      <main class="pub-main">${body}</main>
      <footer class="pub-foot"><span class="ball pu-ball-sm" aria-hidden="true"></span>
        <div><strong>Arceau</strong><small>Édité par IDR · 6 boulevard Marcel Paul, 31170 Tournefeuille</small></div></footer>
    </div>`);
  if (!v) {
    page(html`<section class="pub-thanks"><p class="pub-kicker pu-ko">Lien introuvable</p><h3>Ce lien ne vaut plus</h3>
      <p>Vérifiez le lien reçu dans l’e-mail. Pour toute question : le formulaire sur <a href="${SITE}#question">arceau.app</a>.</p></section>`);
    return;
  }
  const club = v;
  const done = (choice: 'stop' | 'season', fresh: boolean) => page(html`
    <section class="pub-thanks"><p class="pub-kicker">✓ ${fresh ? 'C’est noté' : 'Déjà noté'}</p>
      <h3>${choice === 'stop' ? 'Plus aucun e-mail' : 'Rien cette saison'}</h3>
      <p>${choice === 'stop'
        ? html`Arceau n’écrira plus jamais à ${club.email_hint ? html`<strong>${club.email_hint}</strong>` : 'cette adresse'}.`
        : html`Arceau n’écrira plus à ${club.name} pendant 12 mois.`}</p></section>
    ${choice === 'season' ? html`<section class="card pu-more"><p class="small">Vous préférez ne plus jamais rien recevoir ?</p>
      <button type="button" class="btn btn-ghost btn-sm" data-choice="stop">Ne plus recevoir d’e-mails</button></section>` : ''}
    <p class="hint">Une question ? Le formulaire sur <a href="${SITE}#question">arceau.app</a> (réponse sous 24 h).</p>`);
  const choose = async (b: HTMLButtonElement) => {
    const choice = b.dataset.choice as 'stop' | 'season';
    $$<HTMLButtonElement>(root, '[data-choice]').forEach(x => { x.disabled = true; });
    try {
      const r = await prospectOptout(token, choice);
      done(r === 'unsubscribed' || r === 'stop' ? 'stop' : 'season', true);
      wire();
    } catch {
      $$<HTMLButtonElement>(root, '[data-choice]').forEach(x => { x.disabled = false; });
      const msg = root.querySelector('.form-msg');
      if (msg) msg.textContent = 'Impossible pour le moment. Réessayez dans un instant.';
    }
  };
  const wire = () => $$<HTMLButtonElement>(root, '[data-choice]').forEach(b => b.addEventListener('click', () => void choose(b)));

  if (club.choice) { done(club.choice, false); wire(); return; }
  page(html`
    <section class="pub-sec pu-box">
      <p class="pub-kicker">Prospection d’Arceau</p>
      <h2>${club.name}</h2>
      <p class="pu-lead">${club.email_hint ? html`Les e-mails envoyés à <strong>${club.email_hint}</strong>. ` : ''}Choisissez, en un clic :</p>
      <button type="button" class="card pu-choice" data-choice="season">
        <strong>Pas intéressé pour cette saison</strong><span class="muted small">Plus aucun e-mail pendant 12 mois.</span></button>
      <button type="button" class="card pu-choice" data-choice="stop">
        <strong>Ne plus recevoir d’e-mails</strong><span class="muted small">Définitif : Arceau n’écrira plus jamais à cette adresse.</span></button>
      <p class="form-msg" role="alert"></p>
      <p class="hint">Rien ne change tant que vous n’avez pas cliqué. Une question ? Le formulaire sur <a href="${SITE}#question">arceau.app</a>.</p>
    </section>`);
  wire();
}
